module.exports = __webpack_public_path__ + "static/img/clock.e34f8d90.png";